<template>
  <div class="heighlight-body" @click="close" >
    <div class="heighlight-content " @click.stop :style="{ 'position': fixed ? 'fixed' : 'absolute' }">
      <div class="resume-heighlight" v-if="heighlight && heighlight.length > 0">
        <div class="item-top">
          <img src="https://files.wondercv.com/hr_frontend/heighLights.png">
          <span>简历亮点</span>
        </div>
        <div class="item-list" v-for="(item,index) in heighlight" :key="index + 'a'">
          <div class="blue-leftTop-circle"></div> 
          <span>{{ item }}</span>         
        </div>
      </div>
      <div class="resume-heighlight" v-if="risks && risks.length> 0">
        <div class="item-top">
          <img src="https://files.wondercv.com/hr_frontend/danger.png">
          <span>简历风险</span>
        </div>
        <div class="item-list bg-org" v-for="(item,index) in risks" :key="index + 'b'">
          <div class="red-leftTop-circle"></div> 
          <span>{{ item }}</span>         
        </div>
      </div>
      <div class="resume-heighlight" v-if="basic_tags && basic_tags.length > 0">
        <div class="item-top">
          <img src="https://files.wondercv.com/hr_frontend/peopleTag.png">
          <span>候选人标签</span>
        </div>
        <div class="item-tag" v-if="basic_tags.length > 0">
          <span class="tag-name">基本标签</span>
          <div class="tag-body">
            <div class="tag-color basic-tag" v-for="(tag, index) in basic_tags" :key="index + 'c'">{{tag}}</div>
          </div>    
        </div>
        <div class="item-tag" v-if="education_tags.length > 0">
          <span class="tag-name">教育背景标签</span>
          <div class="tag-body">
            <div class="tag-color edu-tag" v-for="(tag, index) in education_tags" :key="index + 'd'">{{tag}}</div>
          </div>    
        </div>
          <div class="item-tag" v-if="abilities_tags.length > 0">
          <span class="tag-name">资质与能力标签</span>
          <div class="tag-body">
            <div class="tag-color abilities-tag" v-for="(tag, index) in abilities_tags" :key="index + 'e'">{{tag}}</div>
          </div>    
        </div>
          <div class="item-tag" v-if="industry_tags.length > 0">
          <span class="tag-name">行业领域标签</span>
          <div class="tag-body">
            <div class="tag-color industry-tag" v-for="(tag, index) in industry_tags" :key="index + 'f'">{{tag}}</div>
          </div>    
        </div>
        <div class="item-tag" v-if="!!skill_tags">
          <span class="tag-name">技能标签</span>
          <template v-for="(skill,index) in Object.keys(skill_tags)">
            <div class="marb8" :key="index + 'g'" v-if="skill_tags[skill].length > 0" > 
              <div class="skill-name" >
                <span>{{skill}}</span> 
              </div>
              <div class="tag-body" >
                <div class="tag-color skill-tag" v-for="(tag, index) in skill_tags[skill]" :key="index + 'h'">{{tag.skill}}</div>
              </div>    
            </div>      
          </template>
        </div>
      </div>
      <div v-if="isEmpty" class="padtop90" >
        <img src="https://files.wondercv.com/hr_frontend/emptyInfo.png" alt="" class="noInfo">
        <div class="noInfo-text">未从该简历提取到相关信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name:'heighlight',
  props:{
    fixed:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('resumeDetails',['resumeDetail'])
  },
  watch:{
    resumeDetail(){
      this.init()
    }
  },
  data(){
   return {
     portraitData: null,
     show: false,
     heighlight: [],
     risks: [],
     tags: [],
     basic_tags: [],  // 基本标签
     education_tags: [], // 教育背景标签
     industry_tags: [], // 行业领域标签
     abilities_tags: [], // 资质与能力标签
     skill_tags: '', // 技能标签
     isEmpty: false
   }
  },
  created(){
    this.init()
  },
  methods:{
    init(){
      this.reset()  // 数据清空
      this.portraitData = this.resumeDetail.resume.portrait_result
      if( !this.portraitData ){ 
        this.isEmpty = true 
        return
      }
      // 亮点
      Object.keys(this.portraitData.highlights).forEach(key => {
        if ( !!this.portraitData.highlights[key] && key != 'skill' ) {
          this.heighlight.push(this.portraitData.highlights[key])
        }
        if ( key == 'skill' && this.portraitData.highlights[key] instanceof Array ) {
          this.heighlight.push(...this.portraitData.highlights[key])
        }
      })
      // 风险
      Object.keys(this.portraitData.risks).forEach(key => {
        if ( !!this.portraitData.risks[key] ) {
          if ( this.portraitData.risks[key] instanceof Array ) {
            this.risks.push(...this.portraitData.risks[key])
          } else {
            this.risks.push(this.portraitData.risks[key])
          }
        }
      })
      // 候选人标签
      Object.keys(this.portraitData.tags).forEach(key => {
        if( !!this.portraitData.tags[key] && key !== 'skill_tags') {
          Object.keys(this.portraitData.tags[key]).forEach(keyTag => {
            if( this.portraitData.tags[key][keyTag] instanceof Array ) {
              this[key].push(...this.portraitData.tags[key][keyTag])
            }
          })
        } 
      })
      // 资质标签
      this.abilities_tags = this.portraitData.tags.abilities_tags
      // 技能标签
      this.skill_tags = this.portraitData.tags.skill_tags.skill
      // 排除空字符串
      this.risks = this.risks.filter(item => {
        return !!item && !!item.replace(/(^\s*)|(\s*$)/g, "")
      })
      this.basic_tags = this.basic_tags.filter(item => {
        return !!item && !!item.replace(/(^\s*)|(\s*$)/g, "")
      })
      this.education_tags = this.education_tags.filter(item => {
        return !!item && !!item.replace(/(^\s*)|(\s*$)/g, "")
      })
      this.heighlight = this.heighlight.filter(item => {
        return !!item && !!item.replace(/(^\s*)|(\s*$)/g, "")
      })
      // console.log(this.heighlight);
    },
    reset(){
      this.heighlight = []
      this.risks = []
      this.tags = []
      this.basic_tags = [] // 基本标签
      this.education_tags = [] // 教育背景标签
      this.industry_tags = [] // 行业领域标签
      this.abilities_tags = [] // 资质与能力标签
      this.skill_tags = '' // 技能标签
    },
    close(){
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "./heighlight"
</style>
